<template>
    <div id="emailTemplateWrapper">


        <p class="d-flex mb-2" v-if="value == 0">
            <input type="text" class="form-control" placeholder="Nom du nouveau modèle" v-model="name"
                   style="border-bottom-right-radius: 0; border-top-right-radius: 0;">
            <a :href="url + '?name=' + name" :class="{'btn btn-primary': true, 'disabled': name.length < 1}"
               style="border-bottom-left-radius: 0; border-top-left-radius: 0; border-bottom-right-radius: 9999px; border-top-right-radius: 9999px;">Créer</a>
        </p>
        <p class="mt-0 mb-0 text-center" v-if="value == 0">Ou</p>

        <label class="form-label" for="emailTemplate">Modèles sauvegardés</label>
        <div class="d-flex">
            <select class="form-select" id="emailTemplate" name="emailTemplate" v-model="value"
                    :style="value > 0 ? 'border-bottom-right-radius: 0; border-top-right-radius: 0;' : ''">
                <option value="0">Sélectionner un modèle</option>
                <option v-for="(template, id) in templates" :value="id" :key="id">{{ template }}</option>
            </select>
            <a :href="remove + '?template=' + value" class="btn btn-danger" v-if="value > 0" style="border-radius: 0" onclick="return confirm('Êtes-vous sûr de vouloir supprimer cet email marketing ?')">Supprimer</a>
            <a :href="url + '?template=' + value" class="btn btn-primary" v-if="value > 0"
               style="border-bottom-left-radius: 0; border-top-left-radius: 0; border-bottom-right-radius: 9999px; border-top-right-radius: 9999px;">Modifier</a>
        </div>
    </div>
</template>
<script>
export default {
    data()
    {
        return {
            value: 0,
            name: '',
        }
    },
    props: {
        templates: Object,
        url: String,
        remove: String
    },
}
</script>
